import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faCopy, faPlus } from '@fortawesome/free-solid-svg-icons';
import NotificationHistory from './NotificationHistory';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import { toast } from 'react-toastify';

class SMSNotification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            enabled: true,
            daysBefore: 1,
            messageContent: '',
            isSmsNotification: true,
            // savedUrl: "http://api.smscountry.com/SMSCwebservice_bulk.aspx?User=cvrlms&passwd=GaLC57p5*&mobilenumber=8432873830",
            isEditingUrl: false,
            addParameterValues: [
                { name: "Resource_Title", value: 'Resource_Title' },
                { name: "accession_series", value: 'accession_series' },
                { name: "accession_number", value: 'accession_number' },
                { name: "Resource_Author", value: 'Resource_Author' },
                { name: "User_Role", value: 'User_Role' },
                { name: "User_first_Name", value: 'User_first_Name' },
                { name: "User_Last_Name", value: 'User_Last_Name' },
                { name: "Issued_Date", value: 'Issued_Date' },
                { name: "Due_Date", value: 'Due_Date' },
                { name: "Fine_Per_Day", value: 'Fine_Per_Day' },
                { name: "Applicable_Fine", value: 'Applicable_Fine' },
                { name: "College_Name", value: 'College_Name' }
            ],

            // VARIABLES TO display notification history
            isShowNotificationHistory: false,

            smsSettingDataList: [],
            totalSmsSetting: 0
        };
    }

    componentDidMount() {
        this.apiCallToGetPushNotificationData();
    }

    // API CALL TO GET Push notification DATA LIST
    apiCallToGetPushNotificationData = async () => {
        let requestData = {
            "iid": config.institute_id,
            "type": "sms"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_GetSmtpNotification',
            requestData,
            "/api/library/librarySmtpNotificationSetting.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetPushNotificationData();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if (Object.values(apiResult?.data)?.length > 0) {
                    if (apiResult.success == 'true') {
                        const notificationData = Object.values(apiResult.data)[0];

                        this.setState({
                            smsSettingDataList: apiResult.data,
                            totalSmsSetting: apiResult.totalCount,
                        })

                        this.setState({
                            isSmsNotification: notificationData.access === "true" ? true : false,
                            daysBefore: Number(notificationData.days),
                            // savedUrl: notificationData.emailSubject,
                            messageContent: notificationData.emailText
                        })
                    }
                    else {
                        this.setState({
                            smsSettingDataList: [],
                            totalSmsSetting: 0,
                        })
                    }
                } else {
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.setState({
                        smsSettingDataList: [],
                        totalSmsSetting: 0,
                    })
                    this.setState({
                        isSmsNotification: true,
                        daysBefore: 1,
                        // savedUrl: "http://api.smscountry.com/SMSCwebservice_bulk.aspx?User=cvrlms&passwd=GaLC57p5*&mobilenumber=8432873830",
                        messageContent: ''
                    })
                }
            } else {
                this.setState({
                    smsSettingDataList: [],
                    totalSmsSetting: 0,
                })
            }
        }
    }

    handleToggle = () => {
        this.setState(prevState => ({
            enabled: !prevState.enabled
        }));
    };

    handleDaysChange = (event) => {
        this.setState({ daysBefore: event.target.value });
    };

    handleToggleStatus = (isSmsNotification) => {
        this.setState({ isSmsNotification: !isSmsNotification });
    }

    handleContentChange = (event) => {
        this.setState({
            messageContent: event.target.value
        });
    }


    handleCopyUrl = () => {
        navigator.clipboard.writeText(this.state.savedUrl);
        alert("URL copied to clipboard!");
    };

    // close modal for notification history
    closeModalForNotificationHistory = () => {
        this.setState({
            isShowNotificationHistory: false
        })
    }

    // add sms notification
    library_AddSmtpNotification = async () => {
        let requestData = {
            "iid": config.institute_id,
            "type": "sms",
            "access": this.state.isSmsNotification ? "true" : "false",
            "days": Number(this.state.daysBefore),
            // "emailSubject": this.state.savedUrl,
            "emailText": this.state.messageContent,
            "addedBy": config.faculty_id,
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_AddSmtpNotification',
            requestData,
            "/api/library/librarySmtpNotificationSetting.php"
        )

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.library_AddSmtpNotification();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == "success") {

                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.apiCallToGetPushNotificationData();

                } else {
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                toast.error('Something went wrong while getting sms configuration setting. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    // update sms notification
    library_UpdateSmtpNotification = async () => {
        let requestData = {
            "iid": config.institute_id,
            "access": this.state.isSmsNotification ? "true" : "false",
            "days": Number(this.state.daysBefore),
            // "emailSubject": this.state.savedUrl,
            "emailText": this.state.messageContent,
            "updatedBy": config.faculty_id,
            "uniqueId": Object.values(this.state.smsSettingDataList)[0].uniqueId
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_UpdateSmtpNotification',
            requestData,
            "/api/library/librarySmtpNotificationSetting.php"
        )

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.library_UpdateSmtpNotification();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == "success") {

                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.apiCallToGetPushNotificationData();

                } else {
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                toast.error('Something went wrong while getting student list. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    handleOnClick = () => {
        if (Object.values(this.state.smsSettingDataList).length === 0) {
            this.library_AddSmtpNotification()
        } else {
            this.library_UpdateSmtpNotification()
        }
    }

    // METHOD TO ADD PARAMETER
    addParameter = (parameter) => {
        let { messageContent } = this.state;
        let updatedMessage = messageContent + ` {${parameter}}`;
        this.setState({
            messageContent: updatedMessage
        });
    }

    isFormValid = () => {
        const {
            isSmsNotification,
            daysBefore,
            messageContent
        } = this.state;

        if (!isSmsNotification) return true;

        return (
            String(daysBefore).trim() !== '' &&
            String(messageContent).trim() !== ''
        );
    };

    render() {

        return (
            <>
                <div className="notification-container">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center d-flex-with-gap">
                            <span className="textHeadingLabel me-3">Enable /Disable SMS Notification</span>
                            <span
                                onClick={() => this.handleToggleStatus(this.state.isSmsNotification)}
                                style={{
                                    display: 'inline-block',
                                    width: '30px',
                                    height: '16px',
                                    borderRadius: '9.5px',
                                    backgroundColor: this.state.isSmsNotification ? '#0465ac' : 'grey',
                                    position: 'relative',
                                    cursor: 'pointer',
                                }}
                            >
                                <span
                                    style={{
                                        display: 'block',
                                        width: '10px',
                                        height: '10px',
                                        borderRadius: '50%',
                                        backgroundColor: '#fff',
                                        position: 'absolute',
                                        top: '3px',
                                        left: this.state.isSmsNotification ? '16px' : '1px',
                                        transition: 'left 0.3s ease',
                                    }}
                                ></span>
                            </span>
                        </div>

                        <button className="btn btn-outline btn-sm custom-button" onClick={() => {
                            this.setState({
                                isShowNotificationHistory: true
                            });
                        }}>
                            <FontAwesomeIcon icon={faClock} className="me-1 mr-2" />
                            Notification Logs
                        </button>
                    </div>

                    <div className="custom-boarder-width mt-4">
                        <span className="stepsNotificationLabel">Steps to set up SMS Notification</span>
                        <ul className="mt-2 ml-2 p-2">
                            <li className="textHeadingLabel mb-2">
                                In order to send Library Resources due date SMS to the respective candidate, creating a template below is mandatory.  For sending a SMS, parameters approved by the government are included in the template.
                            </li>
                            <li className="textHeadingLabel">
                                This SMS will be triggered
                                <select
                                    className="form-select form-select-sm custom-select w-auto mx-2"
                                    value={this.state.daysBefore}
                                    onChange={this.handleDaysChange}
                                >
                                    <option value={1}>1 Day</option>
                                    <option value={2}>2 Days</option>
                                    <option value={3}>3 Days</option>
                                </select>
                                before due date.
                            </li>
                        </ul>
                    </div>

                    {/* <div className="custom-boarder-width mt-3">
                        <div className="d-flex justify-content-between align-items-center">
                            <label className="form-label mb-1">Saved Url</label>
                            {!this.state.isEditingUrl &&
                                <a
                                    style={{
                                        color: "#007BFF",
                                        fontSize: "14px",
                                        cursor: "pointer",
                                        textDecoration: "none",
                                    }}
                                    onClick={() => this.setState({ isEditingUrl: !this.state.isEditingUrl })}
                                >
                                    Edit
                                </a>
                            }
                        </div>

                        {this.state.isEditingUrl ? (
                            <div className='d-flex justify-content-between align-items-center'>
                                <div style={{ width: '100%' }}>
                                    <input
                                        type="text"
                                        className="form-control mt-1 px-3 py-2"
                                        value={this.state.savedUrl}
                                        onChange={(e) => this.setState({ savedUrl: e.target.value })}
                                    />
                                </div>
                                <div className="d-flex align-items-center ml-2">
                                    <FontAwesomeIcon
                                        icon={["fas", "check"]}
                                        size="lg"
                                        color='green'
                                        className="mr-2"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => this.setState({ isEditingUrl: false })}
                                    />
                                    <FontAwesomeIcon
                                        icon={["fas", "times"]}
                                        size="lg"
                                        color='red'
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => this.setState({ isEditingUrl: !this.state.isEditingUrl })}
                                    />
                                </div>
                            </div>

                        ) : (
                            <div
                                className="d-flex justify-content-between align-items-center rounded px-4 py-3 mt-1"
                                style={{
                                    backgroundColor: "#fff",
                                    fontSize: "14px",
                                    border: "1px dashed #c0c0c0"
                                }}
                            >
                                <span
                                    style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "block",
                                        maxWidth: "95%",
                                        color: "#007BFF",
                                    }}
                                >
                                    {this.state.savedUrl}
                                </span>
                                <FontAwesomeIcon
                                    icon={faCopy}
                                    style={{ cursor: "pointer" }}
                                    onClick={this.handleCopyUrl}
                                />
                            </div>
                        )}
                    </div> */}

                    <div className="custom-boarder-width mt-3">
                        <div className='d-flex justify-content-between align-items-center'>
                            <div><label className="form-label">Saved Url</label></div>
                            <div>
                                <div className="d-flex justify-content-end mb-1">
                                    <button
                                        className="btn btn-outline btn-sm custom-button"
                                        id='orderByDropdownMenu'
                                        data-toggle="dropdown"
                                        aria-expanded="false"
                                        data-bs-toggle="dropdown"
                                        aria-haspopup="true"
                                    >
                                        <FontAwesomeIcon icon={faPlus} className="me-1 mr-2" />
                                        Add Parameters
                                    </button>
                                    <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='orderByDropdownMenu'>
                                        <div id='addParameterDropdown'>
                                            {
                                                this.state.addParameterValues.map((columnInfo, index) => {
                                                    const isSelected = this.state.isOrderByResourcesValue === columnInfo.value;
                                                    return (
                                                        <p
                                                            className="dropdown-item"
                                                            key={columnInfo.name}
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                fontSize: '14px',
                                                                backgroundColor: isSelected ? '#e0f7fa' : 'transparent',
                                                                color: isSelected ? '#0465AC' : 'black',
                                                                cursor: 'pointer',
                                                                padding: '10px'
                                                            }}
                                                            onClick={() => this.addParameter(columnInfo.name)}
                                                        >
                                                            <span style={{ marginRight: 10 }}>{columnInfo.name}</span>
                                                        </p>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Textarea */}
                        <textarea
                            className={`form-control`}
                            rows="5"
                            placeholder={`e.g. Your borrowed resource "Chronicle of Higher Education" is due tomorrow. Please return it on time to avoid late fees.`}
                            value={this.state.messageContent}
                            onChange={this.handleContentChange}
                        />

                        {/* Validation message */}
                        {this.state.isSmsNotification && !this.state.messageContent && (
                            <div className="invalid-feedback d-block text-start mt-1" style={{ color: '#dc3545' }}>
                                Saved URL is required.
                            </div>
                        )}
                    </div>

                    {/* Save Button */}
                    <div className="mt-4">
                        <button className="btn btn-primary" onClick={() => { this.handleOnClick() }} disabled={!this.isFormValid()}>Save</button>
                    </div>
                </div>

                {
                    <NotificationHistory
                        isShowNotificationHistory={this.state.isShowNotificationHistory}
                        closeModalForNotificationHistory={this.closeModalForNotificationHistory}
                        headerName={"SMS"}
                        type="sms"
                    />
                }
            </>
        )
    }
}

export default SMSNotification;